import Hero from '../components/Hero';
import StatsBar from '../components/StatsBar';
import ServiceCards from '../components/ServiceCards';
import HowItWorks from '../components/HowItWorks';
import FleetGallery from '../components/FleetGallery';
import InsurancePanel from '../components/InsurancePanel';

export default function Home() {
  return (
    <>
      <Hero />
      <StatsBar />
      <ServiceCards />
      <HowItWorks />
      <FleetGallery />
      <InsurancePanel />
    </>
  );
}
